import type { SbColor } from '$lib/storyblok/types';

type BentoBackgroundColor = Extract<
	SbColor,
	'brown-6' | 'green-1' | 'green-2' | 'green-3' | 'green-6'
>;

export function getFontColor(color: BentoBackgroundColor) {
	switch (color) {
		case 'green-1':
		case 'green-2':
		case 'green-3':
			return 'text-white';
		case 'green-6':
		case 'brown-6':
		default:
			return 'text-brown-1';
	}
}

export function getSecondaryFontColor(color: BentoBackgroundColor) {
	switch (color) {
		case 'green-1':
			return 'text-green-6';
		case 'green-2':
			return 'text-green-6';
		case 'green-3':
			return 'text-green-6';
		case 'green-6':
			return 'text-green-1';
		case 'brown-6':
			return 'text-brown-4';
		default:
			return 'text-white';
	}
}
